import { render, staticRenderFns } from "./SettingsGroup.vue?vue&type=template&id=4d99a2ae&"
import script from "./SettingsGroup.vue?vue&type=script&lang=js&"
export * from "./SettingsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports